function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_3554",
  "data-name": "Group 3554",
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_399",
  "data-name": "Path 399",
  d: "M0 0h35v35H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_400",
  "data-name": "Path 400",
  d: "M18.947 13.187l4.237-3.162v8.431L18.947 15.3v3.162H9.061v-8.436h9.886zM7.314 22.672h20.107V5.81H4.825v18.809zm.977 2.81L2 30.4v-26A1.409 1.409 0 013.412 3h25.421a1.409 1.409 0 011.412 1.405v19.673a1.409 1.409 0 01-1.412 1.405z",
  transform: "translate(1.377 2.066)",
  fill: "#4269a1"
})));